export default axiosInstance => {
  async function query({ jwt, modality, current }) {
    return (
      await axiosInstance({
        method: "post",
        url: "/liff/pacsImage",
        headers: { jwt },
        data: { modality, current }
      })
    ).data;
  }

  return {
    query
  };
};
